import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../../theme/ISpcTheme';
import { ButtonProps } from '@material-ui/core/Button';

const X_GIRTH = 3;
const X_SIZE = '65%';

export type ButtonOptionToggleClasses = 'root' | 'icon' | 'enabled' | 'iconRemove';

const buttonOptionToggleStyles = makeStyles<ISpcTheme, ButtonProps, ButtonOptionToggleClasses>(
  theme => ({
    root: {
      paddingLeft: 20,
    },
    enabled: {},
    icon: {
      transition: 'transform 0.1s',
      transformOrigin: 'center',

      '&::after, &::before': {
        content: "' '",
        position: 'absolute',
        display: 'block',
        background: props =>
          `${!props.disabled ? (theme.palette as any)[props.color || 'primary'].main : theme.palette.text.disabled}`,
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%)`,
        borderRadius: 999,
      },
      '&::after': {
        width: X_SIZE,
        height: X_GIRTH,
      },
      '&::before': {
        width: X_GIRTH,
        height: X_SIZE,
      },
    },
    iconRemove: {
      transform: 'rotate(45deg)',
    },
  }),
  { name: 'SPC_ButtonOptionToggle' },
);

export default buttonOptionToggleStyles;
